import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useTiktokBusinessManagerStore = defineStore({
  id: 'tiktokBusinessManagerStore',
  state: () => ({
    tiktokBusinessManagers: [],
    tiktokBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getTiktokBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.tiktokBusinessManagersLoading = true

      try {
        const {data} = await axios.get('tiktok/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.tiktokBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.tiktokBusinessManagersLoading = false
      }
    },
  },
})
